import { makeStyles } from '@material-ui/core/styles'
import { useEffect } from 'react'
import InsuranceTilePremium from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTilePremium'
import InsuranceTileBudget from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTileBudget'
import InsuranceTileValue from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTileValue'
import { scrollToTop } from 'src/utils/commonMethods'
import EmptyInsuranceDetails from 'src/components/BuyPolicy/common/EmptyInsuranceDetails'

const HealthInsuranceDetailsTrovity = ({ insuranceQuotes, loading }) => {
  const classes = useStyles()

  useEffect(() => {
    scrollToTop()
  }, [])

  const showNoDetails = () => {
    return !(
      insuranceQuotes?.premiumShield ||
      insuranceQuotes?.budgetGuard ||
      insuranceQuotes?.valueSure
    )
  }

  const showEmptyInsurance = showNoDetails() && !loading

  return (
    <>
      {showEmptyInsurance ? (
        <EmptyInsuranceDetails />
      ) : (
        <div className={classes.insuranceListContainer}>
          {insuranceQuotes?.premiumShield ? (
            <InsuranceTilePremium
              insuranceDetails={insuranceQuotes?.premiumShield || {}}
            />
          ) : null}
          {insuranceQuotes?.budgetGuard ? (
            <InsuranceTileBudget
              insuranceDetails={insuranceQuotes?.budgetGuard || {}}
            />
          ) : null}
          {insuranceQuotes?.valueSure ? (
            <InsuranceTileValue
              insuranceDetails={insuranceQuotes?.valueSure || {}}
            />
          ) : null}
        </div>
      )}
    </>
  )
}

export default HealthInsuranceDetailsTrovity

export const useStyles = makeStyles({
  insuranceListContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '20px',
    animation: '$slideFromBottom 1s ease-out',
  },
  '@keyframes slideFromBottom': {
    '0%': {
      transform: 'translateY(100%)',
    },
    '100%': {
      transform: 'translateY(0)',
    },
  },
})
